<div class="confirm">
	<div class="bg icon" [ngClass]="{'warning': error, 'info': !error}"></div>
	<h2> {{data.title}} </h2>
	<p>{{data.msg}}</p>
	<div class="btn-grp centered">
		<button (click)="onCloseDialog(true)" class="app-btn primary">Aceptar</button>
	</div>
</div>